import type { FaireProductEntity } from "../../entity_types/product";

export const p_yc3aeenv22: FaireProductEntity = {
  token: "p_yc3aeenv22",
  type: "product",
  name: "Important Nonsense List Pad",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/9559d28bad1e5cbdf92219c7ee78d42950c173531e2d9eb5ec57dff001db349e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7ca6b9c7401cf7eae489038868a73191dfa6572041979172fa24688334639560.jpeg"
  ],
  priceDollars: 3,
  description: "A list notepad from our Whimsical Collection displaying a charming scene of a mouse watering a house plant with a relatable sentiment that reads \"Important Nonsense\" and a lined space underneath for writing. Our Important Nonsense list pad includes 60 pages and a strong magnet to easily hang on magnetic surface for display. Proudly made in the USA. A cute gift perfect for adding functional style and personality to any space.",
  tags: [],
  msrpDollars: 5.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:24.701Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
